import { DashboardWebComponent } from './component/DashboardWebComponent';
import { WEB_COMPONENT_DASHBOARD } from '../webcomponents.constants';

export { DashboardWebComponent };

window.customElements.define(WEB_COMPONENT_DASHBOARD, DashboardWebComponent);
